import { Box, Typography } from '@mui/material'
import { USER_PROFILE } from '@/config/userProfile'
import { getProfileInitials } from '@/utils/getProfileInitials'
import styles from './accountMenu.module.scss'

const SIZE_MAP = {
  sm: { shell: styles.avatarInitialsSm, text: styles.avatarInitialsTextSm },
  md: { shell: styles.avatarInitialsMd, text: styles.avatarInitialsTextMd },
}

/**
 * @param {{ fullName?: string, size?: 'sm' | 'md', className?: string }} props
 */
export default function UserProfileInitialsAvatar({
  fullName = USER_PROFILE.fullName,
  size = 'sm',
  className = '',
}) {
  const initials = getProfileInitials(fullName)
  const sizeStyles = SIZE_MAP[size] ?? SIZE_MAP.sm

  return (
    <Box
      className={`${sizeStyles.shell} ${className}`.trim()}
      aria-hidden
    >
      <Typography component="span" className={sizeStyles.text}>
        {initials}
      </Typography>
    </Box>
  )
}
